class PreventScroll {
    static scrollWhitelist = ['ui-popup__content'];

    static init() {
        window.preventScrollLastTouch = 0;
        window.addEventListener('touchstart', ({ touches }) => {
            window.preventScrollLastTouch = touches[0].clientY;
        });
    }

    static setWhitelist(selectors = []) {
        PreventScroll.scrollWhitelist = selectors;
    }

    static preventDefault(event) {
        const isWhitelisted = PreventScroll.scrollWhitelist.some((selector) => event.target.closest(`.${selector}, #${selector}`));

        if (isWhitelisted) {
            return;
        }

        const overflowPopin = PreventScroll.getOverflowParent(event.target);
        if (overflowPopin) {
            const { atTop, atBottom } = PreventScroll.isScrollAtEdge(overflowPopin);

            let delta = 0;
            if (event.type === 'wheel') {
                delta = event.deltaY;
            } else if (event.type === 'touchmove') {
                delta = window.preventScrollLastTouch - event.touches[0].clientY;
            }

            if (atTop && delta < 0) event.preventDefault();
            if (atBottom && delta > 0) event.preventDefault();
        } else {
            event.preventDefault();
        }
    }

    static getOverflowParent(element) {
        let parent = element;

        while (parent && parent !== document.documentElement) {
            const style = getComputedStyle(parent);
            if (style.overflow === 'auto' || style.overflow === 'scroll') {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null;
    }

    static isScrollAtEdge(element) {
        return {
            atTop: element.scrollTop === 0,
            atBottom: element.scrollTop + element.clientHeight >= element.scrollHeight,
        };
    }

    static preventDefaultForScrollKeys(e) {
        // left: 37, up: 38, right: 39, down: 40,
        if (e.keyCode >= 37 && e.keyCode <= 40) {
            e.preventDefault();
            return false;
        }

        return true;
    }

    static getOpt() {
        // modern Chrome requires { passive: false } when adding event
        let supportsPassive = false;
        try {
            window.addEventListener(
                'test',
                null,
                Object.defineProperty({}, 'passive', {
                    get() {
                        supportsPassive = true;
                        return true;
                    },
                }),
            );
        } catch (e) {
            // Do nothing
        }

        const wheelOpt = supportsPassive ? { passive: false } : false;
        const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

        return { wheelEvent, wheelOpt };
    }

    // call this to Disable
    static disableScroll() {
        const { wheelEvent, wheelOpt } = PreventScroll.getOpt();

        window.addEventListener('DOMMouseScroll', PreventScroll.preventDefault, false); // older FF
        window.addEventListener(wheelEvent, PreventScroll.preventDefault, wheelOpt); // desktop
        window.addEventListener('touchmove', PreventScroll.preventDefault, wheelOpt); // mobile
        window.addEventListener('keydown', PreventScroll.preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    static enableScroll() {
        const { wheelEvent, wheelOpt } = PreventScroll.getOpt();

        window.removeEventListener('DOMMouseScroll', PreventScroll.preventDefault, false);
        window.removeEventListener(wheelEvent, PreventScroll.preventDefault, wheelOpt);
        window.removeEventListener('touchmove', PreventScroll.preventDefault, wheelOpt);
        window.removeEventListener('keydown', PreventScroll.preventDefaultForScrollKeys, false);
    }
}

export default PreventScroll;
